module.exports = __webpack_public_path__ + "img/soundcloud.9a99dc04.svg";